import Components from './install-component'

export default Components


// WEBPACK FOOTER //
// ./src/index.js